import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth'
import apiurl from "./apiweb.js";



const obj = {

  getPDF: async (rut, tipodocumento, folio, fechaEmision) => {

    const params = { rut, tipodocumento, folio, fechaEmision }
    console.log(params);
    try {
      const resp = await axios({
        method: "GET",
        url: apiurl + "generarpdf",
        headers: {
          "content-type": "application/json",
          'Authorization': "Bearer " + (await fetchAuthSession()).tokens?.idToken?.toString()
        },
        crossdomain: true,
        params: {
          ...params,
        },
      });
      console.log(resp);
      window.location = resp.data;
      return resp;
    } catch (error) {
      console.log(error);
      return error;
    }
  },
 
}


// const getPDF = async (rut, tipodocumento, folio, fechaEmision) => {
//   // console.log(rut,tipodocumento,folio,fechaEmision);
//   const params = { rut, tipodocumento, folio, fechaEmision }
//   console.log(params);



//   try {
//     const resp = await axios({
//       method: "GET",
//       url: apiurl + "generarpdf",
//       headers: {
//         "content-type": "application/json",
//         'Authorization': "Bearer " + (await fetchAuthSession()).tokens?.idToken?.toString()
//       },
//       crossdomain: true,
//       params: {
//         ...params,
//       },
//     });
//     console.log(resp);
//     window.location = resp.data;
//     return resp;
//   } catch (error) {
//     console.log(error);
//     return error;
//   }




// }

export default obj; 
